"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexRowLayoutReversed = exports.FlexRowLayout = exports.FlexColumnLayout = exports.FlexColumn = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexColumnLayout = _styledComponents.default.div.withConfig({
  displayName: "FlexLayout__FlexColumnLayout",
  componentId: "sc-1ph11n4-0"
})(["display:flex;flex-flow:row wrap;"]);

exports.FlexColumnLayout = FlexColumnLayout;

var FlexColumn = _styledComponents.default.div.withConfig({
  displayName: "FlexLayout__FlexColumn",
  componentId: "sc-1ph11n4-1"
})(["display:flex;flex:", ";"], function (props) {
  return props.grow || 1;
});

exports.FlexColumn = FlexColumn;

var FlexRowLayout = _styledComponents.default.div.withConfig({
  displayName: "FlexLayout__FlexRowLayout",
  componentId: "sc-1ph11n4-2"
})(["display:flex;flex-direction:row;"]);

exports.FlexRowLayout = FlexRowLayout;

var FlexRowLayoutReversed = _styledComponents.default.div.withConfig({
  displayName: "FlexLayout__FlexRowLayoutReversed",
  componentId: "sc-1ph11n4-3"
})(["display:flex;flex-direction:row-reverse;"]);

exports.FlexRowLayoutReversed = FlexRowLayoutReversed;